export const SET_NAVIGATION_DRAWER = 'SET_NAVIGATION_DRAWER';
export const SET_NAVIGATION_STEPBACK_BUTTON = 'SET_NAVIGATION_STEPBACK_BUTTON';
export const SET_NAVIGATION_CLOSE_BUTTON = 'SET_NAVIGATION_CLOSE_BUTTON';
export const SET_NAVIGATION_EXTEND_SESSION = 'SET_NAVIGATION_EXTEND_SESSION';
export const SET_NAVIGATION_USER_ROLE = 'SET_NAVIGATION_USER_ROLE';
export const SET_NEW_USER_CONFIGURATION = 'SET_NEW_USER_CONFIGURATION';
